module.exports = __webpack_public_path__ + "static/media/Faculty-Led.42142724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Faculty-Led.jpg
// module id = 1688
// module chunks = 0